import React, { useState, useEffect, useContext, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useQueries from '../../../../database/useQueries';
import { useSelector } from 'react-redux';
import FormTemplate from '../../../template/form/FormTemplate';
import { formatPriceIL, getFieldOptions } from '../../plagins/data/commponentOptions';
import LoadingOverlay from '../../pagesMains/LoadingOverlay';
import SignatureForm from '../../plagins/signs/SignatureForm';
import { GlobalContext } from '../../../../App';
import CustomDialog from '../../plagins/dialogs/customDialog';
import PaymentsManagement from '../../pagesCreate/paymentsManagementCreate';
import { DataContext, TemplateContext } from '../../pagesMains/GravesManagers/Graves';
import { fullSelectedAreaGraves, fullSelectedBlocks, fullSelectedCemeteries, fullSelectedCustomers, fullSelectedGraves, fullSelectedPlots, fullSelectedRows } from '../../plagins/data/multiSelectedForm';
import { format, parseISO } from 'date-fns';

// הגדרת שם הישות כקבוע
const NAME_ENTITY = 'רכישה';

function PurchaseTransfer({ propPurchase = null }) {
  const stablePropPurchase = useMemo(() => propPurchase, [JSON.stringify(propPurchase)]);
  // קבלת ערכים מהסטור
  const columns = [
    { id: 10, name: 'clientId',           label: 'שם לקוח מעביר',           input: 'selectedFree', width: 250, isActive: true, show: true,                 required: true,             createPermissions: [1], updatePermissions: [1], },
    { id: 10, name: 'newClientId',           label: 'שם לקוח מקבל',           input: 'selectedFree', width: 250, isActive: true, show: true,                 required: true,             createPermissions: [1], updatePermissions: [1], },
  ]

  const context = useContext(DataContext);

  const { permission, setTitle } = useContext(GlobalContext);
  const { setTotalWidthContainer } = useContext(TemplateContext);
  const myPermissions = [];

  // טעינת היוזים לפונקציות עזר
  const {  duplicateAndUpdatePurchase } = useQueries();

  // ערכי הראוטר
  const navigate = useNavigate();

  const [myPurchase, setMyPurchase] = useState(() => {
    const val = stablePropPurchase !== null ? stablePropPurchase : stablePropPurchase;
    const foundItem = context?.contextPurchases?.find((item) => {
      return item?.unicId === val?.unicId;
    });
  
    // יצירת עותק חדש של האובייקט
    return foundItem ? { ...foundItem } : { ...stablePropPurchase };
  });
  

  setTotalWidthContainer(1200);
  setTitle(`עדכון רכישה`);

  // איזור המשתנים והסטייטים
  // משתנים לטופס
  const [fieldsWithDynamicDisabled, setFieldsWithDynamicDisabled] = useState([]); // השדות
  const [formValues, setFormValues] = useState(() => ({}));

  useEffect(() => {
    console.log('test connected');
    console.log(1,formValues);
    console.log(propPurchase);
    

    

  }, [stablePropPurchase,formValues]);
  

  const [errors, setErrors] = useState({}); // שגיאת השדות
  // עוקב אחר שליחת נתונים לשרת דרך פונקציית סבמיט
  const [loadingData, setloadingData] = useState(false);

  // משתנים לערכי סלקט של השדות
  const [clients, setClients] = useState([]);
  const [newClients, setNewClients] = useState([]);

  // פונקציה לטעינת השדות מתוך הסטור
  const myColumns = (localColumns = null) => {
    localColumns = localColumns !== null ? localColumns : columns;
    const tempPermission = permission === 0 || myPermissions.includes(permission);
    return localColumns.map((field, index) => {
      let lock = false;
      lock = field.name === 'cemeteryId' || field.name === 'blockId' || field.name === 'plotId' || field.name === 'lineId' || field.name === 'areaGraveId' || field.name === 'graveId' || field.name === 'clientId' ? true : false;

      if (!tempPermission) {
        lock = field.name === 'BookkeepingApproval' ? true : false;
      }

      return {
        ...field,
        disabled: field.name === 'clientId',
        // disabled: false,
        // disabled: lock ? lock : field.disabled,
        // disabled: !(permission === 0 || field?.updatePermissions?.includes(permission)),
        required: field.name === 'spouse' && formValues.maritalStatus === 2 ? true : field.required || false,
        show: field?.show || false
      };
    });
  };

  // פעולות המתבצעות רק לאחר קבלת דאטה בייס ווליו מהראוטר
  useEffect(() => {
    handleAllDataLoaded();
  }, []);

  // טעינת הנתונים לאחר קבלת הערכים מהדאטה בייס הלוקלי
  const handleAllDataLoaded = () => {
    setFieldsWithDynamicDisabled(myColumns());

    if (propPurchase?.unicId) {

      let initialFormValues = myColumns()
        .filter((field) => field?.name)
        .reduce(
          (acc, field) => {
            let fieldValue = myPurchase[field.name] || '';
            return {
              ...acc,
              [field.name]: fieldValue
            };
          },
          {
            unicId: myPurchase?.unicId
          }
        );

      fieldAuto(myPurchase);

      let tempFormValues = { ...formValues };

      Object.keys(tempFormValues).forEach((key) => {
        console.log(111);

        if (tempFormValues[key] !== undefined && tempFormValues[key] !== null) {
          initialFormValues[key] = tempFormValues[key]; // שמירה על הערכים הקיימים ב-prev
        }
      });

      setFormValues({ ...initialFormValues });
    }
  };

  // טעינת ערכים אוטומטית לשדות
  const fieldAuto = (purchase) => {
    setClients(fullSelectedCustomers(
      [...context?.contextCustomers
        ?.filter((cust) => cust?.statusCustomer !== 2 || (cust?.statusCustomer === 2 && cust?.unicId === purchase?.clientId))])
    )
    setNewClients(fullSelectedCustomers(
      context?.contextCustomers
        ?.filter((cust) => cust?.statusCustomer === 1)
        ?.filter((cust) => cust?.unicId !== purchase?.clientId)
    ))
  };

  //לוגיקת הזנה בשדות הטופס
  const handleChange = (event) => {
    let newFormValues = { ...formValues };
    const {name, value} = event.target

    if (name === 'newClientId') {
      setFieldsWithDynamicDisabled(myColumns());
    }

    setFormValues({
      ...newFormValues,
      [name]: value
    });
  };
  // אימות ערכים
  const validateForm = () => {
    let tempErrors = {};
    let formIsValid = true;

    columns.forEach((field) => {
      // if (field.required && !formValues[field.name]) {
      //   tempErrors[field.name] = 'שדה חובה';
      //   formIsValid = false;
      // }
      // if (field.name === 'clientId' && (formValues[field.name] === '' || formValues[field.name] === null || formValues[field.name] === undefined)) {
      //   tempErrors[field.name] = `שדה חובה`;
      //   formIsValid = false;
      // }
    });

    setErrors(tempErrors);
    return formIsValid;
  };
  // שליחת הטופס
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      setloadingData(true);

      let newFormValues = { ...formValues };
      delete newFormValues?.cemeteryId;
      delete newFormValues?.blockId;
      delete newFormValues?.plotId;
      delete newFormValues?.lineId;
      delete newFormValues?.areaGraveId;
  
      async function executeQueries(newFormValues) {
        try {
          setloadingData(true);
  
          // הוספת נתוני הקבר, הלקוח, והחתימות למבנה הנתונים שנשלח לשרת
          const requestData = {
            ...newFormValues,
            clientId: newFormValues?.newClientId,
          };

          delete requestData?.newClientId
          
          
          console.log(123, requestData);
  
          // שליחת הנתונים לשרת בפנייה אחת
          let res = await duplicateAndUpdatePurchase(requestData);
  
          // בדיקת התוצאה
          if (res === 200) {
            // פעולות לאחר הצלחה
            setloadingData(false);
            navigate(-1);
          } else {
            // טיפול במקרה של כישלון
            console.error('השאילתה נכשלה');
            setloadingData(false);
          }
        } catch (error) {
          console.error('שגיאה בביצוע השאילתות:', error);
          setloadingData(false);
        }
      }
  
      executeQueries(newFormValues);
    }
  };

  if (loadingData) return <LoadingOverlay />;

  return (
    <>
      <FormTemplate
        btn={`עדכן`}
        fields={fieldsWithDynamicDisabled}
        columns={fieldsWithDynamicDisabled}
        formValues={formValues}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        errors={errors}
        options={{
          clientId: clients,
          newClientId: newClients,
        }}
      />
    </>
  );
}

export default PurchaseTransfer;
